import styled from 'styled-components'

interface StyledIconProps {
  padding?: string
}

export const StyledIcon = styled.div<StyledIconProps>`
  display: flex;
  justify-content: end;
  margin: 0 0.2rem 0 0.5rem;
  padding: ${(props) => (props.padding ? props.padding : '0.2rem')};
  align-items: center;
  justify-content: center;
  cursor: pointer;
`
